import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { filterSearch } from "../../features/Filter/filterSlice";

const initialValues = {
  search: "",
};

export default function NavbarFilter() {
  const dispatch = useDispatch();
  const [values, setValues] = useState(initialValues);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(filterSearch(values?.search));
  };
  return (
    <form onSubmit={handleSubmit} className="flex items-center">
      <div className="group relative rounded-md bg-white">
        <svg
          width="20"
          height="20"
          fill="currentColor"
          className="absolute left-3 top-1/2 -mt-2.5 text-slate-400 pointer-events-none group-focus-within:text-primary"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
          ></path>
        </svg>
        <input
          type="text"
          placeholder="Filter books..."
          className="search"
          id="lws-search"
          name="search"
          value={values.search}
          onChange={handleChange}
        />
      </div>
    </form>
  );
}
